<script setup lang="ts">
defineOptions({
  name: 'NewsOverview',
});

const { $mopConfig } = useNuxtApp();
const route = useRoute();
const classNameRef = ref(['']);
const { getLocalePathByPage } = useMopRouter();
const { initTransition } = useMopPageTransitionClient();

const { storyListRef, totalPagesRef, loadingRef } = await useMopCmsStoryListPage({
  cacheKeyPrefix: 'news-overview',
  slug: '/news',
  pageType: 'News',
  getFilterKey: () => (route.params?.category as string | undefined) ?? 'all',
  getFilterParams: () => {
    const category = route.params?.category as string | undefined;
    if (!category) {
      return {};
    }
    if (!$mopConfig.getAvailableNewsCategories().includes(category)) {
      return null;
    }
    return { filter_query: { category: { in: category } } };
  },
});

initTransition(classNameRef, loadingRef);
</script>

<template>
  <div :class="['news-overview-page', 'transition', ...classNameRef]">
    <MopPageLoad :class="classNameRef" />
    <div class="transition-content">
      <template v-if="storyListRef">
        <div v-for="story in storyListRef" :key="story.getUuId()">
          <MopBlogNewsItem :story="story" />
        </div>
        <UiPagination
          v-if="totalPagesRef > 1"
          :key="`news-${totalPagesRef}-${$route.query.fullPath}-${$route.query.page}`"
          :page="`${$route.query.page ?? 1}`"
          :get-locale-path-by-page="getLocalePathByPage"
          :total-pages="totalPagesRef"
          class="news-overview__pagination"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.news-overview__pagination {
  margin-top: $space30;
}
</style>
